import { IConfigurableSvgProps } from "./interfaces";

export const BurgerMenuSvg: React.FC<IConfigurableSvgProps> = ({ strokeColor = "#000000" }) => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<line
			x1="4"
			y1="9"
			x2="28"
			y2="9"
			stroke={strokeColor}
			strokeWidth="2"
		/>
		<line
			x1="4"
			y1="23"
			x2="28"
			y2="23"
			stroke={strokeColor}
			strokeWidth="2"
		/>
	</svg>
);
